export enum TimeInterval {
  ONE_SECOND = 'ONE_SECOND',
  TEN_SECONDS = 'TEN_SECONDS',
  ONE_MINUTE = 'ONE_MINUTE',
  TEN_MINUTES = 'TEN_MINUTES',
  ONE_HOUR = 'ONE_HOUR',
  THREE_HOURS = 'THREE_HOURS',
  ONE_DAY = 'ONE_DAY',
}

export interface LogEventCount {
  date: string
  count: number
}

export interface ChartState {
  data: LogEventCount[]
  interval: TimeInterval | null
  isFetching: boolean
}
